// @flow

import * as React from 'react'
import {
  AreaChart as RCAreaChart,
  Area,
  Brush,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts'
import type { AggregatedVisits } from '../store/reports'

type OwnProps_ = {
  width: string | number,
  height: string | number,
  data: AggregatedVisits,
  startIndex: number,
  endIndex: number,
  showWeb: boolean,
  showPhone: boolean,
  showF2F: boolean,
}
type OwnProps = OwnProps_ & $Shape<OwnProps_>

class AreaChart extends React.Component<OwnProps> {
  renderTooltip = (o: { payload: Array<Object>, label: string }) => {
    const { payload, label } = o
    if (!payload) return
    const total = payload.reduce((result, entry) => result + entry.value, 0)

    return (
      <div
        style={{
          backgroundColor: 'white',
          border: 'solid 1px #cdcdcd',
          padding: '.5rem 1rem',
          borderRadius: '.5rem',
          minWidth: '8rem',
          boxShadow: '.15rem .15rem .15rem rgba(0,0,0,.2)',
        }}>
        <div style={{ fontWeight: 'bold', textDecoration: 'underline' }}>{`${label}`}</div>
        {payload.map((entry, index) => (
          <div key={`item-${index}`} style={{ color: entry.color }}>
            {`${entry.name}: ${entry.value}`}
          </div>
        ))}
        <div>{`Totale: ${total}`}</div>
      </div>
    )
  }

  render() {
    return (
      <ResponsiveContainer width={this.props.width} height={this.props.height}>
        <RCAreaChart data={this.props.data}>
          <XAxis dataKey="name" />
          <YAxis width={30} />
          <Tooltip content={this.renderTooltip} position={{ x: 50, y: 20 }} isAnimationActive={false} />
          <CartesianGrid stroke="#ccc" strokeDasharray="7 9" />
          {this.props.showPhone && (
            <Area
              stackId="1"
              type="monotone"
              dataKey="phone"
              stroke="#F2711C"
              fill="#F2711C"
              isAnimationActive={false}
              dot={true}
            />
          )}
          {this.props.showF2F && (
            <Area
              stackId="1"
              type="monotone"
              dataKey="f2f"
              stroke="#21BA45"
              fill="#21BA45"
              isAnimationActive={false}
              dot={true}
            />
          )}
          {this.props.showWeb && (
            <Area
              stackId="1"
              type="monotone"
              dataKey="web"
              stroke="#2185D0"
              fill="#2185D0"
              isAnimationActive={false}
              dot={true}
            />
          )}
          <Brush
            height={1}
            x={30}
            y={0}
            width={0}
            startIndex={this.props.startIndex}
            endIndex={this.props.endIndex}
            dataKey="name"
            isAnimationActive={false}
          />
        </RCAreaChart>
      </ResponsiveContainer>
    )
  }
}

export default AreaChart



// WEBPACK FOOTER //
// ./src/reports/area-chart.js